import React from "react";
import ControllersTable from "./controllersTable";

const Controllers = () => {
  return <ControllersTable />;
};

export default Controllers;
